import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Groups'));

function LoadableGroups() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableGroups;
